/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListGcpKmsKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListGcpKmsKeysRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListGcpKmsKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGcpKmsKeysSecurity$outboundSchema: z.ZodMiniType<
  ListGcpKmsKeysSecurity$Outbound,
  ListGcpKmsKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listGcpKmsKeysSecurityToJSON(
  listGcpKmsKeysSecurity: ListGcpKmsKeysSecurity,
): string {
  return JSON.stringify(
    ListGcpKmsKeysSecurity$outboundSchema.parse(listGcpKmsKeysSecurity),
  );
}

/** @internal */
export type ListGcpKmsKeysRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGcpKmsKeysRequest$outboundSchema: z.ZodMiniType<
  ListGcpKmsKeysRequest$Outbound,
  ListGcpKmsKeysRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listGcpKmsKeysRequestToJSON(
  listGcpKmsKeysRequest: ListGcpKmsKeysRequest,
): string {
  return JSON.stringify(
    ListGcpKmsKeysRequest$outboundSchema.parse(listGcpKmsKeysRequest),
  );
}
